module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Producten"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten op gescande locatie")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    ref: "table",
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr')]), _vm._v(" "), _c('tbody', _vm._l((_vm.products), function(product) {
    return _c('tr', {
      key: product.id
    }, [_c('td', {
      staticClass: "border-1",
      staticStyle: {
        "width": "500px"
      },
      attrs: {
        "scope": "row"
      }
    }, [_c('div', {
      staticClass: "p-2"
    }, [_c('img', {
      staticClass: "img-fluid rounded shadow-sm",
      attrs: {
        "src": product.image_urls[0],
        "alt": "",
        "width": "70"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ml-3 d-inline-block align-middle"
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('a', {
      staticClass: "text-dark d-inline-block align-middle",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.select(product)
        }
      }
    }, [_vm._v(_vm._s(product.name))])])])])])])
  }), 0)])])]), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2a875ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/LocationScannedModal.vue
// module id = 754
// module chunks = 1